
<template>
  <!-- new code -->
  <div class="wrapper">
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
      <div class="str-logo">
        <img
          :src="$root.serverBasePath + '/strata.png'"
          alt="Strata Connex"
          height="49px"
        />
      </div>

      <div class="content-wrapper">
        <!-- left content -->
        <div class="content__left">
          <h1 class="py-4 fs-2 head-title">
            I love how easy it is to work with tradies <br />
            now with Strata Connex.
          </h1>

          <div class="sidebar-review d-flex flex-row">
            <div>
              <img :src="$root.serverBasePath + '/rev-avatar.png'" />
            </div>

            <div>
              <p class="pl-3">
                <strong>Trade Contractor</strong><br />
                <span class="text-sm d-block">Infinity Management</span>
              </p>
            </div>
          </div>

          <div class="forgot-pwd-img">
            <img
              :src="$root.serverBasePath + '/pwd.png'"
              alt="Strata Connex"
            />
          </div>
        </div>

        <!-- content right -->
        <div class="content-wrapper-form">
          <div class="forgot-form">
              <div class="password-arrow">
              <router-link :to="{ name: 'login' }" class="left-arrow text-center">
                 <i
                class="fa fa-angle-left fa-lg" aria-hidden="true"
              ></i>
              </router-link>
              </div>
              <h2 class="mb-3 font-weight-bold text-center py-3">
                Forgot Password ?
              </h2>
              <p class="my-4 text-center instruct" style="">
                Enter your email address and we'll send you an email with
                instructions to reset your password.
              </p>
              <b-form
                @submit.prevent="submitForm"
                @keydown="form.onKeydown($event)"
              >
                <b-alert v-if="message" show dismissible variant="success">
                  {{ message }}
                </b-alert>

                <b-form-group label="Email Address">
                  <b-form-input
                    v-model="form.email"
                    type="text"
                  placeholder="Email"
                    v-bind:class="{
                      'is-invalid': form.errors.has('email'),
                    }"
                  ></b-form-input>
                  <has-error :form="form" field="email"></has-error>
                </b-form-group>

                <b-button
                  class="btn-grad mx-auto pwd-reset"
                  variant="primary"
                  type="submit"
                  :disabled="form.busy"
                  >Reset Password
                </b-button>

                <p class="text-center mt-4 mb-0">
                <router-link :to="{ name: 'login' }" style="text-decoration:none"> Cancel </router-link>
                </p>
              </b-form>
          </div>
        </div>
      </div>
    </b-overlay>

    <footer-component> </footer-component>
  </div>
  <!-- wrapper ends -->
  <!-- new code ends -->
</template>

<script>
import { Form, HasError } from "vform";
import FooterComponent from "../pages/includes/FooterComponent.vue";

Vue.component(HasError.name, HasError);

export default {
  components: {
    FooterComponent,
  },
  data() {
    return {
      form: new Form({
        email: "",
      }),
      message: "",
    };
  },
  methods: {
    submitForm() {
      this.$root.$data.bsLoader = true;

      this.form.post("forgot-password").then((response) => {
        this.message = response.data.message;
        this.$root.$data.bsLoader = false;
      }).catch((err) => {
         this.$root.$data.bsLoader = false;
      });
    },
  },
};
</script>

<style scoped>

p.instruct {
  font-size: clamp(0.85rem, 4vw, 1.1rem);
  line-height: 30px;
}

h1.head-title {
  font-size: clamp(1.25rem, 3vw, 1.6875rem) !important;
}

.auth-brand {
  margin-bottom: 0;
}

.forgot-pwd-img {
    display: flex;
    justify-content: center;
    width: 100%;
}

.forgot-pwd-img img {
    width: 100%;
    max-width: 500px;
}


@media screen and (max-width: 1100px) {
  br {
    display: none;
  }
}

/****************
    RESPONSIVE
    MEDIA
    QUERIES IN
    ACTION
****************/

@media screen and (max-width: 500px) {
  p.instruct {
    line-height: 25px;
  }

  .pwd-reset {
    font-size: clamp(0.75rem, 3vw, 1rem);
  }
}
</style>
